var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.691 13.781v1.406A2.816 2.816 0 0 1 9.88 18H2.813A2.816 2.816 0 0 1 0 15.187V2.813A2.816 2.816 0 0 1 2.813 0h7.066a2.816 2.816 0 0 1 2.812 2.813v1.406a.703.703 0 1 1-1.406 0V2.812c0-.775-.63-1.406-1.406-1.406H2.813c-.776 0-1.407.631-1.407 1.407v12.374c0 .776.631 1.407 1.407 1.407h7.066c.775 0 1.406-.631 1.406-1.407v-1.406a.703.703 0 1 1 1.406 0Zm4.794-5.989-1.574-1.574a.703.703 0 1 0-.995.994l1.12 1.12H7.594a.703.703 0 1 0 0 1.406h8.442l-1.12 1.12a.703.703 0 1 0 .995.995l1.574-1.575a1.76 1.76 0 0 0 0-2.486Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.3c40e2e076b1d1772880b5bb28f3ad96.svg";
export { ForwardRef as ReactComponent };